import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {
  faPencilAlt,
  faTrashAlt,
  faArrowsAlt
} from '@fortawesome/fontawesome-free-solid';

class AnswerDisplay extends Component {

  render() {
    return (
      <li style={{backgroundColor:"white"}}>
        <div className="answer-container">
          {this.props.answer.answer}
          <span className="answer-options">
          <span {...this.props.dragHandle.dragHandleProps}>
              <FontAwesomeIcon icon="arrows-alt" /></span>
            <span onClick={this.props.editAnswer.bind(this, this.props.answer)}>
              <FontAwesomeIcon icon="pencil-alt" /></span>
            <span onClick={this.props.deleteAnswer.bind(this, this.props.answer)}>
              <FontAwesomeIcon icon="trash-alt" /></span>
          </span>
        </div>
      </li>
    )
  }
}

export default AnswerDisplay;



// WEBPACK FOOTER //
// ./src/components/questions/modify/AnswerDisplay.js